import { getProductIds } from 'src/app/utils/analytics/utils/getProductIds';
import { getProductPurchaseId } from 'src/app/utils/analytics/utils/getProductPurchaseId';
import { getProductQuantities } from 'src/app/utils/analytics/utils/getProductQuantities';
import { getPriceVisibility } from 'src/app/v1/dataAnalytics/utils/getPriceVisibility';
import type { Tealium } from 'src/types/appState';

import { EVENT_NAME_VIEW_REFRESH } from '../constants';

export const eventName = EVENT_NAME_VIEW_REFRESH;

export default (tealium: Tealium) => {
  const {
    adBudgetPurchased,
    salaryRangeSelected,
    roleTitle,
    cajaFlowType,
    jobAdTypeSelected,
    jobAdTypePosted,
    jobAdClassification,
    jobAdSubClassification,
    productSetId,
    priceVisibility,
    seekListingId,
    productTotalPrice,
  } = tealium;
  return {
    adSalaryRangeSelected: salaryRangeSelected,
    jobTitle: roleTitle,
    cajaFlowType,
    jobClassification: jobAdClassification,
    jobSubClassification: jobAdSubClassification,
    productSetId,
    adStatus: 'open',
    isPriceHidden: getPriceVisibility(priceVisibility),
    productPurchaseId: getProductPurchaseId(seekListingId),
    productQuantities: getProductQuantities(adBudgetPurchased),
    productTotalPrice: [productTotalPrice],
    productTransactionId: getProductPurchaseId(seekListingId),
    productIds: getProductIds(
      jobAdTypeSelected,
      jobAdTypePosted,
      adBudgetPurchased,
    ),
  };
};
